// @ts-nocheck
import React, { useEffect } from "react";
import "../PasskeyPage/passkey.css";
import { useWithdrawPage } from "./WithdrawPageContext";
import { SAVE_ADDR_WIZARD_STEP } from "./withdrawPageShared";

export default function AddressBookVerificationModals() {
  const {
    isSaveAddressOpen,
    saveAddrWizardStep,
    verificationContext,
    addrBookVerificationOptionsState,
    addrBookVerificationOptionsLoading,
    addrBookVerifyStage,
    addrBookOtpKind,
    addrBookOtpBoxes,
    setAddrBookOtpBoxes,
    addrBookOtpBusy,
    addrBookOtpSending,
    addrBookOtpResendSec,
    addrBookMaskedEmailDisplay,
    addrBookMaskedPhoneDisplay,
    saveAddrSaving,
    handleAddressBookPasskeyFlow,
    addrBookOtpSetDigit,
    addrBookOtpKeyDown,
    addrBookOtpPasteFromClipboard,
    submitAddrBookOtpFromBoxes,
    addrBookBackToMethodPicker,
    sendAddressBookSingleOtp,
  } = useWithdrawPage();

  const handleInputPaste = (e) => {
    const text = e.clipboardData?.getData("text") || "";
    const digits = String(text || "").replace(/\D/g, "").slice(0, 6).split("");
    if (digits.length > 0) {
      e.preventDefault();
      setAddrBookOtpBoxes((prev) => {
        const next = [...prev];
        for (let i = 0; i < digits.length; i++) {
          if (i < 6) {
            next[i] = digits[i];
          }
        }
        return next;
      });
      const focusIndex = Math.min(digits.length, 5);
      requestAnimationFrame(() => {
        document.getElementById(`addr-book-otp-${focusIndex}`)?.focus();
      });
    }
  };

  const methods = addrBookVerificationOptionsState?.available_methods ?? [];

  const showFlow =
    verificationContext === "address_book" &&
    isSaveAddressOpen &&
    saveAddrWizardStep === SAVE_ADDR_WIZARD_STEP.VERIFY_ACCOUNT &&
    !addrBookVerificationOptionsLoading &&
    methods.length > 0 &&
    addrBookVerifyStage !== "idle";

  const isOtpComplete = addrBookOtpBoxes.every((d) => d !== "");

  useEffect(() => {
    if (showFlow && addrBookVerifyStage === "otp") {
      requestAnimationFrame(() => document.getElementById("addr-book-otp-0")?.focus());
    }
  }, [showFlow, addrBookVerifyStage, addrBookOtpKind]);

  if (!showFlow) return null;

  if (addrBookVerifyStage === "passkey") {
    return (
      <div className="passkey-modal-overlay" role="presentation">
        <div
          className="passkey-modal"
          role="dialog"
          aria-modal="true"
          aria-labelledby="addr-book-passkey-title"
        >
          <button
            type="button"
            className="passkey-modal__close"
            aria-label="Close"
            onClick={() => addrBookBackToMethodPicker()}
          >
            ×
          </button>

          <div className="passkey-modal__art" aria-hidden="true">
            <img className="light_img" src="/images/passkey_vector_light.svg" alt="" />
            <img className="dark_img" src="/images/passkey_vector.svg" alt="" />
          </div>

          <h2 id="addr-book-passkey-title" className="passkey-modal__title">
            Verify with passkey
          </h2>

          <button
            type="button"
            className="passkey-verify-modal__confirm"
            disabled={saveAddrSaving}
            onClick={() => void handleAddressBookPasskeyFlow()}
          >
            {saveAddrSaving ? "Verifying…" : "Verify"}
          </button>

          {methods.length > 1 ? (
            <button type="button" className="passkey-modal__cancel" onClick={() => addrBookBackToMethodPicker()}>
              Back
            </button>
          ) : null}
        </div>
      </div>
    );
  }

  if (addrBookVerifyStage === "otp" && addrBookOtpKind) {
    const kind = addrBookOtpKind;
    const title =
      kind === "email"
        ? "Verify Your Email"
        : kind === "mobile"
          ? "Verify your mobile"
          : "Authenticator verification";
    const subtitle =
      kind === "email"
        ? `The verification code has been sent to your email ${addrBookMaskedEmailDisplay || "on file"
        }, valid for 10 minutes.`
        : kind === "mobile"
          ? `The verification code has been sent to ${addrBookMaskedPhoneDisplay || "your phone"}, valid for 10 minutes.`
          : "Enter the 6-digit code from your authenticator app.";

    const showResend = kind === "email" || kind === "mobile";
    const resendSec =
      kind === "email" ? addrBookOtpResendSec.email : kind === "mobile" ? addrBookOtpResendSec.mobile : 0;
    const sending = kind === "email" ? addrBookOtpSending.email : kind === "mobile" ? addrBookOtpSending.mobile : false;

    return (
      <div className="passkey-modal-overlay" role="presentation">
        <div
          className="passkey-modal passkey-verify-modal"
          role="dialog"
          aria-modal="true"
          aria-labelledby="addr-book-otp-title"
        >
          <button
            type="button"
            className="passkey-modal__close"
            aria-label="Close"
            onClick={() => addrBookBackToMethodPicker()}
          >
            ×
          </button>

          <h2 id="addr-book-otp-title" className="passkey-verify-modal__title">
            {title}
          </h2>
          <p className="passkey-verify-modal__subtitle">{subtitle}</p>

          <div className="passkey-verify-modal__otpRow" aria-label="Verification code" onPaste={handleInputPaste}>
            {addrBookOtpBoxes.map((digit, idx) => (
              <input
                // eslint-disable-next-line react/no-array-index-key
                key={idx}
                id={`addr-book-otp-${idx}`}
                className="passkey-verify-modal__otp"
                value={digit}
                inputMode="numeric"
                pattern="[0-9]*"
                maxLength={1}
                autoComplete={idx === 0 ? "one-time-code" : undefined}
                aria-label={`Digit ${idx + 1}`}
                onInput={(e) => addrBookOtpSetDigit(idx, e)}
                onChange={(e) => addrBookOtpSetDigit(idx, e)}
                onKeyDown={(e) => addrBookOtpKeyDown(idx, e)}
                onPaste={handleInputPaste}
              />
            ))}
          </div>

          <div className={`passkey-verify-modal__links${!showResend ? " passkey-verify-modal__links--totp" : ""}`}>
            {showResend && (
              <button
                type="button"
                className="passkey-verify-modal__link"
                disabled={resendSec > 0 || addrBookOtpBusy || sending}
                onClick={() => void sendAddressBookSingleOtp(kind)}
                style={resendSec > 0 ? { opacity: 0.55, cursor: "not-allowed", textDecoration: "none" } : undefined}
              >
                {sending ? "Sending…" : resendSec > 0 ? `Resend in ${resendSec}s` : "Resend"}
              </button>
            )}
            <button type="button" className="passkey-verify-modal__link passkey-verify-modal__link--paste" onClick={() => void addrBookOtpPasteFromClipboard()}>
              Paste{" "}
              <span aria-hidden="true">
                <i className="ri-file-copy-fill" />
              </span>
            </button>
          </div>

          <button
            type="button"
            className="passkey-verify-modal__confirm"
            disabled={!isOtpComplete || addrBookOtpBusy}
            onClick={() => void submitAddrBookOtpFromBoxes()}
          >
            {addrBookOtpBusy ? "Verifying…" : "Confirm"}
          </button>

          {methods.length > 1 ? (
            <div className="passkey-verify-modal__footerRow">
              <button type="button" className="passkey-verify-modal__chooseOther" onClick={() => addrBookBackToMethodPicker()}>
                Choose other verification method
              </button>
            </div>
          ) : null}
        </div>
      </div>
    );
  }

  return null;
}
